import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=0f5bb0f8&scoped=true"
import script from "./ProviderList.vue?vue&type=script&lang=js"
export * from "./ProviderList.vue?vue&type=script&lang=js"
import style0 from "./ProviderList.vue?vue&type=style&index=0&id=0f5bb0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5bb0f8",
  null
  
)

export default component.exports